export default __webpack_public_path__ + "static/national-yards-desktop-571d51ad20a5fbdb4216775f4f7fc06c.svg";